var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Updates-Oct-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subscriptions",
    transform: "translate(-1249.000000, -788.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 616.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1169.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(80.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71699525,0 0,6.71699525 0,15 C0,23.2830047 6.71699525,30 15,30 C23.2830047,30 30,23.2830047 30,15 C30,6.71699525 23.2830047,0 15,0 Z",
    id: "Shape",
    fill: "#F45C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8488312,11.695404 C21.8554687,11.8430329 21.8586731,11.9913483 21.8586731,12.1403503 C21.8586731,16.6898346 18.3956909,21.9360352 12.0627594,21.936264 L12.0629883,21.936264 L12.0627594,21.936264 C10.1184082,21.936264 8.3090973,21.3663483 6.78543094,20.3897095 C7.05482484,20.4215241 7.32902525,20.4373169 7.60665891,20.4373169 C9.21981809,20.4373169 10.7043457,19.887085 11.8828583,18.9635467 C10.3756714,18.9356232 9.10491943,17.9402161 8.66638184,16.5721893 C8.87626646,16.6124725 9.09210205,16.6344452 9.3134308,16.6344452 C9.62768555,16.6344452 9.93209836,16.5921021 10.221405,16.5131378 C8.64601137,16.1977386 7.45925906,14.8054505 7.45925906,13.1382751 C7.45925906,13.1227112 7.45925906,13.1087494 7.4597168,13.0943298 C7.92366029,13.3522796 8.45420836,13.5074616 9.01908873,13.5248566 C8.09463504,12.90802 7.48695375,11.8535614 7.48695375,10.6590271 C7.48695375,10.0282288 7.6574707,9.43725586 7.95318604,8.92845152 C9.65103152,11.011734 12.1884155,12.3818207 15.0498962,12.5257874 C14.9908447,12.2735596 14.9604035,12.0108032 14.9604035,11.7407227 C14.9604035,9.84008789 16.5023804,8.29811098 18.4037018,8.29811098 C19.3940735,8.29811098 20.2885437,8.71673584 20.9168244,9.38598633 C21.7012024,9.23126221 22.4377441,8.94470215 23.1031037,8.55033873 C22.8456116,9.35394287 22.2999573,10.0282288 21.5890503,10.4546356 C22.2855377,10.3713226 22.9492951,10.186615 23.5661316,9.91241455 C23.1053924,10.602951 22.5210571,11.2094879 21.8488312,11.695404 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.97a85568265f1815f6e551ff49d5fc1a.svg";
export { ForwardRef as ReactComponent };